import { render, staticRenderFns } from "./CustomerServiceChat.vue?vue&type=template&id=3be08f3f&scoped=true&"
import script from "./CustomerServiceChat.vue?vue&type=script&lang=js&"
export * from "./CustomerServiceChat.vue?vue&type=script&lang=js&"
import style0 from "./CustomerServiceChat.vue?vue&type=style&index=0&id=3be08f3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be08f3f",
  null
  
)

export default component.exports